document.addEventListener('click',function(e){
  var q=e.target.closest('[data-qty]');
  if(q){var input=q.parentElement.querySelector('input');var v=parseInt(input.value||'1',10);
    v=q.dataset.qty==='up'?v+1:Math.max(1,v-1);input.value=v;syncQty(input);return;}
});
/* show the chosen quantity in the product sticky bar, e.g. "3 x 300 x 100 mm" */
function syncQty(input){
  if(!input||input.name!=='quantity')return;
  var n=parseInt(input.value||'1',10);
  document.querySelectorAll('[data-sticky-qty]').forEach(function(el){
    el.hidden=!(n>1);el.textContent=n>1?n+' x ':'';
  });
}
document.addEventListener('input',function(e){if(e.target.name==='quantity')syncQty(e.target);});

document.addEventListener('change',function(e){
  var s=e.target.closest('[data-variant-select]');
  if(!s)return;
  var o=s.options[s.selectedIndex];
  document.querySelectorAll('[data-price-inc]').forEach(function(el){el.textContent=o.dataset.inc;});
  document.querySelectorAll('[data-price-ex]').forEach(function(el){el.textContent=o.dataset.ex;});
  document.querySelectorAll('[data-sticky-size]').forEach(function(el){el.textContent=o.dataset.size||'';});
  var u=new URL(window.location.href);
  u.searchParams.set('variant',o.value);
  history.replaceState(null,'',u.toString());
});

/* sticky bottom bars (product: add to basket, basket: checkout). each bar points at
   the real button it stands in for. mode "past" (product page) shows the bar only once
   the shopper has scrolled beyond the button; the default shows it whenever the button
   is off screen. the top margin allows for the sticky header covering the button */
(function(){
  var bars=document.querySelectorAll('[data-sticky-bar]');
  if(!bars.length||!('IntersectionObserver' in window))return;
  var header=document.querySelector('.header');
  var top=header?Math.round(header.getBoundingClientRect().height):0;
  bars.forEach(function(bar){
    var target=document.querySelector(bar.getAttribute('data-sticky-bar'));
    if(!target)return;
    var pastOnly=bar.getAttribute('data-sticky-mode')==='past';
    var io=new IntersectionObserver(function(entries){
      var e=entries[0];
      var shown=!e.isIntersecting&&(!pastOnly||e.boundingClientRect.top<top);
      bar.classList.toggle('is-visible',shown);
      document.documentElement.classList.toggle('has-sticky-bar',shown);
    },{threshold:0,rootMargin:'-'+top+'px 0px 0px 0px'});
    io.observe(target);
    bar.querySelector('[data-sticky-action]').addEventListener('click',function(){
      var form=target.closest('form');
      if(form&&form.requestSubmit){form.requestSubmit(target);}else{target.click();}
    });
  });
})();

/* collection filters: a bottom sheet below 1024px. on small screens ticking a box no
   longer reloads straight away, so several filters can be chosen, then applied */
(function(){
  var side=document.querySelector('[data-filter-drawer]');
  if(!side)return;
  var scrim=document.querySelector('[data-filter-scrim]');
  var opener=document.querySelector('[data-filter-open]');
  var small=window.matchMedia('(max-width:1023px)');
  function open(){
    side.classList.add('is-open');side.setAttribute('aria-hidden','false');
    if(scrim)scrim.hidden=false;
    document.documentElement.classList.add('is-locked');
    var c=side.querySelector('.drawer__close');c&&c.focus({preventScroll:true});
  }
  function close(){
    if(!side.classList.contains('is-open'))return;
    side.classList.remove('is-open');side.setAttribute('aria-hidden','true');
    if(scrim)scrim.hidden=true;
    document.documentElement.classList.remove('is-locked');
    opener&&opener.focus({preventScroll:true});
  }
  document.querySelectorAll('[data-filter-open]').forEach(function(b){b.addEventListener('click',open);});
  document.querySelectorAll('[data-filter-close]').forEach(function(b){b.addEventListener('click',close);});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')close();});
  side.querySelectorAll('input[type="checkbox"]').forEach(function(cb){
    cb.addEventListener('change',function(ev){
      if(small.matches){ev.stopImmediatePropagation();return;}
      cb.form&&cb.form.submit();
    });
  });
})();


/* despatch message on product pages: worked out in UK time so it never promises
   "despatch today" at weekends, on bank holidays or after the 4pm cut-off.
   England and Wales bank holidays, 2026 and 2027 */
(function(){
  var els=document.querySelectorAll('[data-despatch]');
  if(!els.length||!window.Intl)return;
  var hols=['2026-01-01','2026-04-03','2026-04-06','2026-05-04','2026-05-25','2026-08-31','2026-12-25','2026-12-28',
            '2027-01-01','2027-03-26','2027-03-29','2027-05-03','2027-05-31','2027-08-30','2027-12-27','2027-12-28'];
  function uk(d){
    var p={};new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/London',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',hour12:false,weekday:'short'})
      .formatToParts(d).forEach(function(x){p[x.type]=x.value;});
    return {ymd:p.year+'-'+p.month+'-'+p.day,day:p.weekday,h:parseInt(p.hour,10)%24,m:parseInt(p.minute,10)};
  }
  function working(t){return t.day!=='Sat'&&t.day!=='Sun'&&hols.indexOf(t.ymd)<0;}
  function update(){
    var now=new Date(),t=uk(now),msg;
    var mins=16*60-(t.h*60+t.m);
    if(working(t)&&mins>0){
      var h=Math.floor(mins/60),m=mins%60;
      msg='Order within '+(h?h+'h ':'')+m+'m for despatch today.';
    }else{
      var d=new Date(now.getTime()),n;
      for(var i=1;i<10;i++){d=new Date(now.getTime()+i*864e5);n=uk(d);if(working(n))break;}
      var name=new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/London',weekday:'long'}).format(d);
      msg='Order now for despatch '+(i===1?'tomorrow':'on '+name)+'.';
    }
    els.forEach(function(el){el.textContent=msg;});
  }
  update();setInterval(update,60000);
})();
